<template>
  <el-container>
    <h1>资产</h1>
  </el-container>
</template>

<script>
 
  export default {
     name: 'Property_Get',
     data () {
       return {

        };
     },

     methods: {

     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Get.vue